module.exports = __webpack_public_path__ + "img/process_title_bac.3b677c36.png";